export default __webpack_public_path__ + "static/media/politics.1e9a05f3.txt";